<div class="input-grid-gaps grid-4col formGrid">
    <app-insurance-company-select-input
        id="insuranceAbbr"
        [form]="form">
    </app-insurance-company-select-input>
    <label class="font-bold text-uppercase">{{ prefix + 'title' | translate }}</label>
    <app-service-doctor-select-input
        class="fr-2"
        [form]="form"
    ></app-service-doctor-select-input>

    <hr class="fr-4"/>

    <app-text-input class="fr-3" [form]="form" id="fullName" prefix="ePrescriptions.form."></app-text-input>
    <app-text-input [form]="form" id="insuranceNumber" prefix="ePrescriptions.form."></app-text-input>
    <app-address-input class="fr-4" [form]="form" id="address" prefix="ePrescriptions.form."></app-address-input>
    <app-diagnosis-select-input class="fr-4" [form]="form" id="diagnosis"
        label="person.dashboard.diagnosis"></app-diagnosis-select-input>

    <hr class="fr-4"/>

    @if (magistraliterEnabled) {
        <div class="fr-4 flex justify-content-between align-items-center gap-small">
            <label for="itemType">{{ 'ePrescriptions.form.fields.itemType' | translate }}</label>
            <app-radio-input
                [form]="form"
                id="itemType"
                [staticOptions]="ePrescriptionItemTypeEnumOptions"
                [autoSelectFirst]="true"
            ></app-radio-input>
        </div>

        <hr class="fr-4"/>
    }

    @if (itemTypeChanged() === EPrescriptionItemTypeEnum.MEDICATION) {
        <label class="fr-4 font-bold">{{ 'ePrescriptions.form.labelMedication1' | translate }}</label>

        <app-select-medication class="fr-4" [form]="form" id="medicationCode1" [showClear]="true"
            label="ePrescriptions.form.fields.medicationCode"></app-select-medication>

        <app-number-input [form]="form" id="packages1" label="ePrescriptions.form.fields.packages"></app-number-input>
        <div class="flex justify-content-evenly">
            <app-check-input [form]="form" id="checkP1" label="ePrescriptions.form.fields.checkP"></app-check-input>
        </div>
        <app-text-input class="fr-2" [form]="form" id="denturSignentur1"
            label="ePrescriptions.form.fields.denturSignentur"></app-text-input>

        <app-check-input class="fr-2" [form]="form" id="addPaidByEmployer1"
            label="ePrescriptions.form.fields.addPaidByEmployer"
        ></app-check-input>

        <hr class="fr-4"/>

        <label class="fr-4 font-bold">{{ 'ePrescriptions.form.labelMedication2' | translate }}</label>

        <app-select-medication class="fr-4" [form]="form" id="medicationCode2" [showClear]="true"
            label="ePrescriptions.form.fields.medicationCode"></app-select-medication>

        <app-number-input [form]="form" id="packages2" label="ePrescriptions.form.fields.packages"></app-number-input>
        <div class="flex justify-content-evenly">
            <app-check-input [form]="form" id="checkP2" label="ePrescriptions.form.fields.checkP"></app-check-input>
        </div>
        <app-text-input class="fr-2" [form]="form" id="denturSignentur2"
            label="ePrescriptions.form.fields.denturSignentur"></app-text-input>

        <app-check-input class="fr-2" [form]="form" id="addPaidByEmployer2"
            label="ePrescriptions.form.fields.addPaidByEmployer"
        ></app-check-input>
    } @else {
        <section class="fr-4 flex-column gap-small" aria-labelledby="magistraliter-heading">
            <div class="flex justify-content-between align-items-start gap-small">
                <div>
                    <div id="magistraliter-heading" class="font-bold">
                        {{ 'ePrescriptions.form.magistraliter.title' | translate }}
                    </div>
                    <div class="text-secondary">
                        {{ 'ePrescriptions.form.magistraliter.description' | translate }}
                    </div>
                </div>
                <div class="flex flex-wrap gap-x-small">
                    <app-button
                        icon="pi-folder-open"
                        label="ePrescriptions.form.magistraliter.loadTemplate"
                        severity="secondary"
                        [outlined]="true"
                        [hideLabel]="true"
                        [title]="'ePrescriptions.form.magistraliter.loadTemplate' | translate"
                        (clickEvent)="openMagistraliterTemplates()"
                    ></app-button>
                    <app-button
                        icon="pi-save"
                        label="ePrescriptions.form.magistraliter.saveTemplate"
                        severity="secondary"
                        [outlined]="true"
                        [hideLabel]="true"
                        [title]="'ePrescriptions.form.magistraliter.saveTemplate' | translate"
                        (clickEvent)="saveMagistraliterTemplate()"
                    ></app-button>
                    <app-button
                        icon="pi-plus"
                        label="ePrescriptions.form.magistraliter.addIngredient"
                        severity="secondary"
                        [outlined]="true"
                        (clickEvent)="addMagistraliterIngredient()"
                    ></app-button>
                    <app-folder-e-prescription-magistraliter-recipes
                        (recipeSelected)="applyMagistraliterRecipe($event)"
                    ></app-folder-e-prescription-magistraliter-recipes>
                </div>
            </div>

            <div class="input-grid-gaps grid-4col">
                <app-text-input
                    class="fr-2"
                    [form]="form"
                    id="magistraliterName"
                    label="ePrescriptions.form.fields.magistraliterName"
                    [maxLength]="146"
                ></app-text-input>
                <app-select-input
                    [form]="form"
                    id="magistraliterForm"
                    label="ePrescriptions.form.fields.magistraliterForm"
                    [infiniteScroll]="isCannabisMagistraliter()
                        ? store.suklCannabisPharmaceuticalFormScroll
                        : store.suklPharmaceuticalFormScroll"
                    valueKey="code"
                    labelKey="name"
                    idField="code"
                    filterBy="code,name"
                    filterMatchMode="remote"
                ></app-select-input>
                <app-select-input
                    [form]="form"
                    id="magistraliterAdministrationRoute"
                    label="ePrescriptions.form.fields.magistraliterAdministrationRoute"
                    [infiniteScroll]="store.suklAdministrationRouteScroll"
                    valueKey="code"
                    labelKey="name"
                    idField="code"
                    filterBy="code,name"
                    filterMatchMode="remote"
                ></app-select-input>
            </div>

            <div class="flex-column gap-x-small" role="group"
                [attr.aria-label]="'ePrescriptions.form.magistraliter.ingredients' | translate">
                @if (!form.controls.magistraliterIngredients.length) {
                    <small class="text-secondary">
                        {{ 'ePrescriptions.form.magistraliter.ingredientsOptional' | translate }}
                    </small>
                }
                @for (ingredientForm of form.controls.magistraliterIngredients.controls; track ingredientForm; let index = $index) {
                    <div class="magistraliter-ingredient-row input-grid-gaps align-items-start pt-2">
                        <span class="font-bold pt-2">{{ index + 1 }}</span>
                        <app-select-input
                            [form]="ingredientForm"
                            id="type"
                            label="ePrescriptions.form.fields.ingredientType"
                            [staticOptions]="ePrescriptionMagistraliterIngredientTypeEnumOptions"
                            [showClear]="false"
                            (selectionChange)="magistraliterIngredientTypeChanged(ingredientForm)"
                        ></app-select-input>
                        @switch (ingredientForm.controls.type.value) {
                            @case (EPrescriptionMagistraliterIngredientTypeEnum.REGISTERED_MEDICATION) {
                                <app-select-medication
                                    [form]="ingredientForm"
                                    id="registeredMedicationCode"
                                    label="ePrescriptions.form.fields.ingredientMedication"
                                    [showClear]="true"
                                    (selectionChange)="registeredMedicationSelected(ingredientForm, $event)"
                                ></app-select-medication>
                            }
                            @case (EPrescriptionMagistraliterIngredientTypeEnum.CANNABIS) {
                                <app-select-input
                                    [form]="ingredientForm"
                                    id="substanceCode"
                                    label="ePrescriptions.form.fields.ingredientCannabis"
                                    [staticOptions]="cannabisSubstances"
                                    [showClear]="true"
                                    (selectionChange)="cannabisSubstanceSelected(ingredientForm, $event)"
                                ></app-select-input>
                            }
                            @default {
                                <app-input-text-autocomplete
                                    [form]="ingredientForm"
                                    id="name"
                                    [label]="'ePrescriptions.form.fields.ingredientName' | translate"
                                    [suggestions]="store.data.searchEPrescriptionMagistraliterIngredientNames() || []"
                                    [suggestFnc]="suggestMagistraliterIngredientNames"
                                    [showEmptyMessage]="false"
                                    [maxLength]="200"
                                ></app-input-text-autocomplete>
                            }
                        }
                        <app-number-input
                            [form]="ingredientForm"
                            id="amount"
                            label="ePrescriptions.form.fields.ingredientAmount"
                            [min]="0.000001"
                            [max]="999999999.999999"
                            [maxFractionDigits]="6"
                            [useGrouping]="false"
                            locale="cs-CZ"
                        ></app-number-input>
                        <app-select-input
                            [form]="ingredientForm"
                            id="unit"
                            label="ePrescriptions.form.fields.ingredientUnit"
                            [staticOptions]="ePrescriptionIngredientUnitEnumOptions"
                            [showClear]="false"
                        ></app-select-input>
                        <app-button
                            icon="pi-trash"
                            severity="danger"
                            [text]="true"
                            [hideLabel]="true"
                            [title]="'ePrescriptions.form.magistraliter.removeIngredient' | translate"
                            (clickEvent)="removeMagistraliterIngredient(index)"
                        ></app-button>
                    </div>
                }
            </div>

            @if (isCannabisMagistraliter()) {
                <app-warn-float-message
                    message="ePrescriptions.form.magistraliter.cannabisWarning"
                    [showSeverityText]="false"
                ></app-warn-float-message>
            }

            <app-text-area-input
                [form]="form"
                id="magistraliterPreparationProcedure"
                label="ePrescriptions.form.fields.magistraliterPreparationProcedure"
                [rows]="3"
            ></app-text-area-input>

            <div class="input-grid-gaps grid-4col">
                <app-number-input
                    [form]="form"
                    id="magistraliterAmount"
                    label="ePrescriptions.form.fields.magistraliterAmount"
                    [min]="1"
                    [max]="999"
                    [useGrouping]="false"
                ></app-number-input>
                <div class="flex justify-content-evenly">
                    <app-check-input
                        [form]="form"
                        id="magistraliterPCheck"
                        label="ePrescriptions.form.fields.checkP"
                    ></app-check-input>
                </div>
                <app-text-input
                    class="fr-2"
                    [form]="form"
                    id="magistraliterDosing"
                    label="ePrescriptions.form.fields.denturSignentur"
                    [maxLength]="80"
                ></app-text-input>
                <app-check-input
                    class="fr-2"
                    [form]="form"
                    id="magistraliterPaymentByEmployer"
                    label="ePrescriptions.form.fields.addPaidByEmployer"
                ></app-check-input>
            </div>
        </section>
    }

    <hr class="fr-4"/>

    <app-text-input class="fr-4" [form]="form" id="note" prefix="ePrescriptions.form."></app-text-input>

    <div class="fr-4">
        <label for="notificationType">{{ prefix + 'labels.notificationType' | translate }}</label>
        <app-radio-input [form]="form" id="notificationType"
            [staticOptions]="ePrescriptionNotificationEnumOptions" [autoSelectFirst]="true"
        ></app-radio-input>
    </div>

    @if (notificationTypeChanged() === EPrescriptionNotificationEnum.SMS) {
        <app-phone-input
            class="fr-4"
            [form]="form"
            id="notificationContact"
            label="ePrescriptions.form.fields.notificationPhone"
        ></app-phone-input>
    } @else {
        <app-text-input
            class="fr-4"
            [form]="form"
            id="notificationContact"
            label="ePrescriptions.form.fields.notificationEmail"
        ></app-text-input>
    }

    <div class="fr-4 dialogButtons dialogButtons-fullWidth">
        <div class="flex gap">
            <!--            <app-button icon="pi-print" [disabled]="true" label="ePrescriptions.buttons.print"></app-button>-->
            <!--            <app-button icon="pi-send" label="ePrescriptions.buttons.sendBySMSEmail"-->
            <!--                (clickEvent)="sendBySMSEmail($event)"></app-button>-->
        </div>

        <app-save-button icon="pi-send" [label]="prefix + 'labels.saveAndSend' + form.controls.notificationType.value"
            (click)="saveAndSend()"></app-save-button>
    </div>
</div>
